export enum Profile {
    user = 'user',
    company = 'company',
}
